import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '@/utils/api';
import { useTenant } from '@/contexts/TenantContext';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const location = useLocation();
  const { tenantPath } = useTenant();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);
  const [isLoading, setIsLoading] = useState(!location.state?.user);
  
  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsAuthenticated(true);
      setUser(location.state.user);
      setIsLoading(false);
      return;
    }
    
    const checkAuth = async () => {
      try {
        const response = await api.get('/auth/me');
        const userData = response.data;
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, [location.state]);
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#334155] border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to={tenantPath('/login')} state={{ from: location }} replace />;
  }
  
  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to={tenantPath('/dashboard')} replace />;
  }
  
  return children;
}
